export default "__VITE_ASSET__2463a0e7__"